import React, { useState, useEffect } from "react";
import CustomModal from "./CustomModal";
import AuthInput from "../Input/AuthInput";
import AddingLightLoader from "../Loaders/AddingLightLoader";
import { ErrorToast, SuccessToast, WarningToast } from "../../utils/ShowToast";
import { CreateRawMaterialApi } from "../../ApiRequests"; // Updated API function
import AuthBtn from "../Buttons/AuthBtn";
import { Popover, Typography } from "@mui/material";
import { BiSolidChevronDown } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { fetchSuppliers } from "../../store/Slices/SupplierSlice";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";

const CreateInvoiceModal = ({ Open, setOpen }) => {
  const [ProductName, setProductName] = useState("");
  const [ProductCode, setProductCode] = useState("");
  const [Quantity, setQuantity] = useState("");
  const [Price, setPrice] = useState("");
  const [Customer, setCustomer] = useState("");
  const [ML, setML] = useState("");
  const [Loading, setLoading] = useState(false);
  const [SelectedCustomer, setSelectedCustomer] = useState("");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log("Closing popover...");
    setAnchorEl(null); // ✅ Ensures popover closes
  };
  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;

  const dispatch = useDispatch();
  const Customers = useSelector((state) => state.Customers);

  useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (ProductName === "") {
      WarningToast("Enter a valid product name");
    } else if (SelectedSupplier === "") {
      WarningToast("Select a supplier");
    } else if (Price === "" || isNaN(Price) || Price <= 0) {
      WarningToast("Enter a valid price");
    } else {
      try {
        const response = await CreateRawMaterialApi({
          supplierId: SelectedSupplier._id,
          supplier_name: SelectedSupplier.name,
          name: ProductName,
          price: Price,
        });

        if (response.data.success) {
          setOpen(false);
          SuccessToast("Raw material added successfully");
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to add raw material");
      }
    }
    setLoading(false);
  };

  return (
    <CustomModal open={Open} setOpen={setOpen}>
      <div className="pb-8">
        <h1 className="w-full text-center font-[700] text-3xl py-8">
          Create New Invoice
        </h1>
        <div className="flex flex-col px-10 gap-y-4">
          <div
            // className="px-4 py-[6px] border-2 border-white rounded-full cursor-pointer bg-[#465462] text-white"
            className={`relative text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink px-4 py-3 rounded-lg font-quicksand font-bold text-sm flex gap-x-6 items-center active:scale-[.99]`}
            onClick={handleClick}
          >
            <div className="flex items-center justify-between w-full">
              <div
                // type="text"
                // name="date"
                // id="date"
                // placeholder="Month"
                // value={CurrentMonth}
                className="w-full outline-none text-left bg-transparent"
                // disabled
                // onClick={handleClick}
              >
                {SelectedCustomer === ""
                  ? "Select Customer"
                  : SelectedCustomer?.name}
              </div>
              <BiSolidChevronDown
                className="text-[1.5rem] cursor-pointer text-muted"
                aria-describedby={id}
                variant="contained"
              />
            </div>
          </div>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            PaperProps={{
              sx: {
                borderRadius: "12px",
                backgroundColor: "#ffffff",
                width: "100%",
                maxWidth: "300px",
                overflow: "hidden",
                marginTop: "10px",
                border: "1px solid #E5E9EB",
                boxShadow:
                  "0 10px 30px rgba(16,69,70,0.12), 0 2px 8px rgba(16,69,70,0.08)",
              },
            }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Typography
              sx={{
                p: 2,
                backgroundColor: "#ffffff",
                overflow: "hidden",
                borderRadius: "12px",
              }}
            >
              <div className="bg-card text-ink font-quicksand flex flex-col justify-center items-center rounded-lg">
                <div className="w-full flex flex-col justify-between gap-y-3 items-start">
                  {Customers.data &&
                    Customers.data.map((customer, i) => {
                      return (
                        <div
                          className="flex gap-x-3 items-center cursor-pointer"
                          onClick={() => {
                            setSelectedCustomer(customer);
                            handleClose();
                          }}
                        >
                          <input
                            type="checkbox"
                            className="mr-1 h-4 w-4 rounded border border-line accent-main"
                            checked={SelectedCustomer._id === customer._id}
                            readOnly
                            onChange={() => {}} // Empty onChange to prevent warning
                          />
                          <span>{customer.name}</span>
                        </div>
                      );
                    })}
                </div>
              </div>
            </Typography>
          </Popover>
          <AuthInput
            label="Product Code"
            placeholder="Enter Product Code"
            Value={ProductCode}
            setValue={setProductCode}
          />
          <AuthInput
            label="Price"
            placeholder="Enter Price"
            Value={Price}
            setValue={setPrice}
            type="number"
          />
        </div>
        <div className="flex justify-center items-center gap-x-2 mt-5 px-5">
          {Loading ? (
            <AddingLightLoader />
          ) : (
            <>
              <AuthBtn
                title={"Add Raw Material"}
                onSubmit={onSubmit}
                type={1}
              />
              <AuthBtn
                title={"Cancel"}
                onSubmit={() => setOpen(false)}
                type={2}
              />
            </>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default CreateInvoiceModal;
